
import { Component, Mixins } from "vue-property-decorator";
import SideMenuLayout from "@/views/sidebar/side-menu-layout.vue";
import ParticipantMixin from "@/views/sidebar/commercial-participant/participant.mixin";
import BaseMixin from "@/views/base/base.mixin";
import VueSelect from 'vue-select';

type SideMenuLayoutInstance = InstanceType<typeof SideMenuLayout>;
type VueSelectInstance = InstanceType<typeof VueSelect>;

@Component({
  components: {
    "side-menu-layout": SideMenuLayout
  }
})
export default class ParticpantComponent extends Mixins(ParticipantMixin, BaseMixin ) {
  loading = false;
  participantNumber = "";
  participantId = 0;

  alertVisible = false;
  alertMessage = "";
  alertVariant = "success";

  async mounted() {
    this.loading = true;
    this.participantId = this.$sidebar.state?.item.participantId;
    const client = await this.waitForClientReady();
    if (client) {
      await this.fetchData();
    } else {
      console.warn("Client not ready in time.");
    }
    this.loading = false;
  }

  async fetchData() {
    const fetch = [
      await this.$store.dispatch("CommercialParticipant/fetchCommercialParticipant", { 
        clientId: this.selectedClientDDL.value, 
        participantId: this.participantId 
      }),
    ];
    await Promise.all(fetch);
  }

  async saveParticipant() {
    this.formSubmitted = false;
    this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        this.commercialParticipant.clientId = this.selectedClientDDL.value;
        await this.$store.dispatch("CommercialParticipant/UpsertParticipant", 
          this.commercialParticipant
        );
        this.loading = false
        if (!this.errorMessage) {
          this.$sidebar.close( {success: true, reload: true} );
        } else {
          (this.$refs.sideMenu as SideMenuLayoutInstance).showAlert();
        }
     }
    });
  }

  handleBlur(refName: string): void {
    const selectComponent = this.$refs[refName] as VueSelectInstance
    const input = selectComponent?.$el?.querySelector('input')
    input?.blur()
  }
}
